import { Routes, Route, Navigate } from 'react-router'
import { ToastContainer } from '@/components/ui/Toast'
import { useEffect, useState } from 'react'
import { LoginPage } from '@/pages/LoginPage'
import { ChatPage } from '@/pages/ChatPage'
import { RoomView } from '@/components/rooms/RoomView'
import { useAuthStore } from '@/lib/store/auth-store'
import { Spinner } from '@/components/ui/Spinner'

function AuthGuard({ children }: { children: React.ReactNode }) {
  const { isLoggedIn } = useAuthStore()
  if (!isLoggedIn) return <Navigate to="/login" replace />
  return <>{children}</>
}

export function App() {
  const { restoreSession } = useAuthStore()
  const [restoring, setRestoring] = useState(true)

  useEffect(() => {
    restoreSession().finally(() => setRestoring(false))
  }, [restoreSession])

  if (restoring) {
    return (
      <div className="h-screen flex items-center justify-center bg-[rgb(var(--np-base))]">
        <div className="text-center">
          <Spinner size={32} className="mx-auto mb-4" />
          <p className="text-sm text-[rgb(var(--np-tx-muted))]">Loading...</p>
        </div>
      </div>
    )
  }

  return (
    <>
    <ToastContainer />
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/*"
        element={
          <AuthGuard>
            <ChatPage />
          </AuthGuard>
        }
      >
        <Route index element={null} />
        <Route path="room/:roomId" element={<RoomView />} />
      </Route>
    </Routes>
    </>
  )
}
